// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import 'normalize.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-default/index.css'
import VueClipboard from 'vue-clipboard2'
import VCharts from 'v-charts'
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
Vue.use(VCharts)
Vue.use(ElementUI, {
  locale
})
Vue.use(VueClipboard)
Vue.config.productionTip = false
let http = Axios.create({
  baseURL: ''
})

http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log('the error.response.status is ----', error.response.status)
    if (error.response.status === 401) {
      window.localStorage.setItem('user-token', '') // 将token清空
      window.localStorage.setItem('user-name', '')
      window.localStorage.setItem('user-id', '')
      window.localStorage.setItem('token-expire', 'true')
      window.history.go(0)
    }
    return Promise.reject(error)
  })

Vue.prototype.$http = http

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js